export const PERSONAL_INFORMATION_FORM = 'personalInformation'

export const FIRST_NAME_PROPERTY = 'firstName'
export const LAST_NAME_PROPERTY = 'lastName'
export const ADDRESS_LINE1_PROPERTY = 'address1'
export const ADDRESS_LINE2_PROPERTY = 'address2'
export const CITY_PROPERTY = 'city'
export const STATE_PROPERTY = 'state'
export const ZIP_CODE_PROPERTY = 'zipCode'
export const CELL_PHONE_NUMBER_PROPERTY = 'primaryPhone'
export const OTHER_PHONE_NUMBER_PROPERTY = 'alternatePhone'
export const MONTH_PROPERTY = 'birthMonth'
export const DAY_PROPERTY = 'birthDay'

export const BIRTHDAY_HINT_ID = 'birthday_hint'
